import { render, staticRenderFns } from "./custom-list-item.vue?vue&type=template&id=3856299e&scoped=true"
import script from "./custom-list-item.vue?vue&type=script&lang=js"
export * from "./custom-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3856299e",
  null
  
)

export default component.exports